/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_item = {
    readonly serviceId: string | null;
    readonly pdpDetailsDisplay: ReadonlyArray<{
        readonly detailKey: string | null;
        readonly delimiter: string | null;
        readonly detailDisplayName: string | null;
        readonly detailValues: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetail_detailValues">;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_item" | "PdpSharedDetailReference_item">;
    readonly " $refType": "PdpRespDetails_item";
};
export type PdpRespDetails_item$data = PdpRespDetails_item;
export type PdpRespDetails_item$key = {
    readonly " $data"?: PdpRespDetails_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDetails_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pdpDetailsDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "PdpDetail",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailKey",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "delimiter",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "detailDisplayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "detailValues",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_item",
      "args": null
    }
  ]
};
(node as any).hash = 'bc158b584a053ea1bd056a197e79cf01';
export default node;
